/**************************************************
 * Nombre:       Tarjeta_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import {FONDOCARD, metasDos, metasTres, metasUno, todos} from "../../Constantes";
import {QuestionMark} from "@mui/icons-material";
import PremioPlan from "./Componentes/PremioPlan";
import Barra_Plan_Carrera from "../../Modulo_Graficas/Graficas/Barra_Plan_Carrera";
import {useObtenerAncho} from "../../Modulo_Graficas/Hooks/useObtenerAncho";
import {useContext, useEffect, useRef, useState} from "react";
import {obtenerTotalPuntos} from "../../CodigoCliente/Puntos/obtenerTotalPuntos";
import {usuarioContext} from "../../App";
import PremioAlcanzado from "./Componentes/PremioAlcanzado";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Cange_Puntos from "../Dialogos/Dialogo_Cange_Puntos";

const Tarjeta_Plan_Carrera = () => {
    const refe = useRef(null);
    const cData = useContext(usuarioContext)
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Cange_Puntos, titulo: 'Cange de puntos'})
    const {ancho} = useObtenerAncho({contenedor: refe})
    const [puntos, setPuntos] = useState(0)


    useEffect(() => {
        obtenerTotalPuntos(cData.usuario.id).then((dox) => {
            setPuntos(dox)
        })
    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                ...FONDOCARD,
                p: 2,
                color: '#fff',
                minHeight: 170
            }}
        >

            <Dialogo/>
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 4, sm: 2, md: 2}} sx={{justifyContent: 'flex-start',}}>
                        <Typography sx={{fontSize: 16, fontWeight: 400}}>Plan Carrera</Typography>
                    </Grid>

                    <Grid container size={{xs: 2, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                        <IconButton sx={{backgroundColor: '#D9D9D9', width: 24, height: 24}}>
                            <QuestionMark sx={{width: 20, height: 20}}/>
                        </IconButton>
                    </Grid>

                    <Grid container size={{xs: 6, sm: 4, md: 4}}
                          sx={{justifyContent: 'flex-end', mt: 0, color: '#000'}}>
                        <PremioPlan items={todos} puntos={puntos}/>
                    </Grid>

                </Grid>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 2}}
            >

                <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{fontSize: 12, fontWeight: 500}}>{`Puntos directos actuales: ${puntos}`}</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end'}}>
                    <Typography sx={{fontSize: 12, fontWeight: 500}}>Puntos Máximos 300.000</Typography>
                </Grid>


            </Grid>

            <Grid container ref={refe} size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: 1, px: 0, mb: 4}}>
                <Barra_Plan_Carrera metas={metasUno} valor={puntos} ancho={ancho}/>
            </Grid>

            <Grid container ref={refe} size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: -3, px: 0, mb: 4}}>
                <Barra_Plan_Carrera metas={metasDos} valor={puntos} ancho={ancho}/>
            </Grid>

            <Grid container ref={refe} size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: -3, px: 0, mb: 4}}>
                <Barra_Plan_Carrera metas={metasTres} valor={puntos} ancho={ancho}/>
            </Grid>

            <Grid container size={{xs: 6, sm: 3, md: 3}} sx={{justifyContent: 'flex-start', pr: 1}}>
                <PremioAlcanzado items={todos} puntos={puntos}/>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Plan_Carrera

